function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.6 13.4596C3.44904 13.4596 4.17135 12.917 4.43904 12.1596H10.075C11.6904 12.1596 13 10.85 13 9.23462C13 7.61918 11.6904 6.30962 10.075 6.30962H2.925C2.02754 6.30962 1.3 5.58208 1.3 4.68462C1.3 3.78716 2.02754 3.05962 2.925 3.05962H4.93076L4.09038 3.9L5.00962 4.81924L7.41924 2.40962L5.00962 0L4.09038 0.919239L4.93076 1.75962H2.925C1.30957 1.75962 0 3.06919 0 4.68462C0 6.30005 1.30957 7.60962 2.925 7.60962H10.075C10.9725 7.60962 11.7 8.33715 11.7 9.23462C11.7 10.1321 10.9725 10.8596 10.075 10.8596H4.43904C4.17135 10.1022 3.44904 9.55962 2.6 9.55962C1.52304 9.55962 0.65 10.4327 0.65 11.5096C0.65 12.5866 1.52304 13.4596 2.6 13.4596Z",
  fill: ""
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4 0.459605C11.477 0.459605 12.35 1.33265 12.35 2.40961C12.35 3.48656 11.477 4.3596 10.4 4.3596C9.32304 4.3596 8.45 3.48656 8.45 2.40961C8.45 1.33265 9.32304 0.459605 10.4 0.459605Z",
  fill: ""
});

var SvgIconPath = function SvgIconPath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-path.c4dffc52.svg";
export { ForwardRef as ReactComponent };